import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { makeStyles } from "tss-react/mui"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ResourceType } from "../../../../../serviceCenter/admin/organization/resources/resourcesTypes"
import { iterateStringEnum } from "../../../../../../lib/enums"

type ResourceTypeFilterProps = Readonly<{
    value: ResourceType
    onChange: (type: ResourceType) => void
}>

const useStyles = makeStyles()(() => ({
    input: {
        width: "15rem",
    },
}))

export function ResourceTypeFilter({ value, onChange }: ResourceTypeFilterProps) {
    const { classes } = useStyles()

    return (
        <FormControl className={classes.input}>
            <LocalizedStrict id="table-select-resource-type-filter-by-label">
                <InputLabel id="table-select-filter-by-resource-type">Resource type</InputLabel>
            </LocalizedStrict>
            <Select
                labelId="table-select-filter-by-resource-type"
                id="multiple-checkbox-resource-type"
                value={value}
                onChange={(e) => onChange(e.target.value as ResourceType)}
            >
                {[...iterateStringEnum(ResourceType)].map((value) => (
                    <MenuItem key={value} value={value}>
                        <LocalizedEnum base="table-select-resource-type-filter-by" enumValue={value}>
                            <span>{value}</span>
                        </LocalizedEnum>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
